const variants = {
  success: "bg-green-400/10 text-green-400 border-green-400/20",
  warning: "bg-amber-400/10 text-amber-400 border-amber-400/20",
  danger: "bg-red-400/10 text-red-400 border-red-400/20",
  info: "bg-blue-400/10 text-blue-400 border-blue-400/20",
  default: "bg-bg-elevated text-text-muted border-border",
};

const Badge = ({ label, variant = "default" }) => (
  <span
    className={`inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium border ${variants[variant]}`}
  >
    {label}
  </span>
);

export default Badge;
